import { useState, useEffect, useContext, useCallback } from "react";
import "../../App.css";
import Box from "@mui/material/Box";

import CollapsibleTable from "../../components/collapsible-table";
import TagRole from "../../components/tag-role";
import Avatar from "@mui/material/Avatar";
import DialogUi from "../../components/dialog";
import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { UserContext } from "../../context";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, InputLabel } from "@mui/material";
import useWorker from "../../hooks/worker";
import useCompanies from "../../hooks/companies";
import UploadButton from "../../components/upload-button";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../config/firebase-config";

const WorkerList = () => {
  const {
    get: getWorkerList,
    edit: editWorker,
    create: createWorker,
    uploadPhoto,
  } = useWorker();
  const { get: getCompanies } = useCompanies();
  const userWorker = useContext(UserContext);
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

  const [workerId, setWorkerId] = useState("");
  const [workerName, setWorkerName] = useState("");
  const [workerEmail, setWorkerEmail] = useState("");
  const [workerPhone, setWorkerPhone] = useState("");
  const [workerRole, setWorkerRole] = useState("");
  const [workerCompanyId, setWorkerCompanyId] = useState("");

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setWorkerRole((event.target as HTMLInputElement).value);
  };
  const handleClickOpeEdit = (data: UserWorker) => {
    setOpenEdit(true);
    setWorkerId(data.id);
    setWorkerName(data.name);
    setWorkerPhone(data.phone);
    setWorkerRole(data.role);
    setWorkerEmail(data.email);
    setWorkerCompanyId(data.companyId);
  };
  const handleClose = () => {
    setOpenCreate(false);
    setOpenEdit(false);
    setWorkerId("");
    setWorkerName("");
    setWorkerPhone("");
    setWorkerRole("");
    setWorkerEmail("");
    setWorkerCompanyId("");
  };

  const handleEdit = async () => {
    const newFields = {
      name: workerName,
      email: workerEmail,
      phone: workerPhone,
      companyId: workerCompanyId,
      role: workerRole,
    };
    await editWorker(workerId, newFields);
    getUsers();
    handleClose();
  };

  const handleSuccess = async () => {
    await createWorker({
      name: workerName,
      email: workerEmail,
      firstAccess: true,
      phone: workerPhone,
      role: workerRole,
      companyId: workerCompanyId,
      photo: null,
    });

    await createUserWithEmailAndPassword(auth, workerEmail, "hph123");
    getUsers();
    handleClose();
  };
  const handleClickOpenCreate = () => {
    setOpenCreate(true);
    getcompanies();
  };

  const [users, setUsers] = useState<UserWorker[]>([]);
  const [companies, setCompanies] = useState<Company[]>([]);

  const handleUploadPhoto = async (id: string, photoUrl: File) => {
    await uploadPhoto(id, photoUrl);
    getUsers();
  };

  const getUserCompany = (id: string) => {
    const companiesFilter = companies.filter((company) => id === company.id);
    const userCompany =
      companiesFilter.length > 0 ? companiesFilter[0] : undefined;
    if (userCompany) return userCompany?.fantasyName;

    return "";
  };
  const getUsers = useCallback(() => {
    const fn = async () => {
      const resp = await getWorkerList();
      setUsers(resp);
    };
    fn();
  }, []);
  const getcompanies = useCallback(() => {
    const fn = async () => {
      const resp = await getCompanies();
      setCompanies(resp);

      if (userWorker.user?.role !== "master") {
        const companiesFilter = companies.filter(
          (company) => userWorker.user?.companyId === company.id
        );
        const userCompany =
          companiesFilter.length > 0 ? companiesFilter[0] : undefined;
        if (userCompany) setWorkerCompanyId(userCompany?.id);
      }
    };
    fn();
  }, []);

  useEffect(() => {
    getUsers();
    getcompanies();
  }, [getUsers, getcompanies]);

  const handleChangeCompanyId = (event: SelectChangeEvent) => {
    setWorkerCompanyId(event.target.value as string);
  };

  const roleCanPerform = (role: string) => {
    const { user } = userWorker;
    if (user?.role === "master") {
      return ["owner", "maintainer", "worker"].includes(role);
    }
    if (user?.role === "owner") {
      return ["maintainer", "worker"].includes(role);
    }
    if (user?.role === "maintainer") {
      return ["worker"].includes(role);
    }
    return false;
  };

  const workerForm = () => {
    const stylesColorLabel = {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      alignItems: "center",
    };

    const roles = ["master", "owner", "maintainer", "worker"].filter((role) => {
      const { user } = userWorker;
      if (user?.role === "master") {
        return ["owner", "maintainer", "worker"].includes(role);
      }
      if (user?.role === "owner") {
        return ["maintainer", "worker"].includes(role);
      }
      if (user?.role === "maintainer") {
        return ["worker"].includes(role);
      }
      return false;
    });

    const companiesFilter = companies.filter(
      (company) => userWorker.user?.companyId === company.id
    );
    const userCompany =
      companiesFilter.length > 0 ? companiesFilter[0] : undefined;

    return (
      <Box
        component="form"
        sx={{
          minWidth: "500px",
          minHeight: "3ls00px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          paddingTop: "12px",
        }}
        noValidate
        autoComplete="off"
      >
        {userWorker.user?.role === "master" ? (
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Worker company
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={workerCompanyId}
              label="Worker company"
              onChange={handleChangeCompanyId}
            >
              {companies.map((company) => (
                <MenuItem value={company.id}>{company.fantasyName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          "Company: " + userCompany?.fantasyName
        )}
        <TextField
          id="outlined-basic"
          label="Worker name"
          variant="outlined"
          value={workerName}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setWorkerName(event.target.value);
          }}
        />
        <TextField
          id="outlined-basic"
          label="Worker email"
          variant="outlined"
          value={workerEmail}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setWorkerEmail(event.target.value);
          }}
        />
        <TextField
          id="outlined-basic"
          label="Worker phone"
          variant="outlined"
          value={workerPhone}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setWorkerPhone(event.target.value);
          }}
        />
        <RadioGroup
          row
          aria-labelledby="demo-error-radios"
          name="quiz"
          value={workerRole}
          onChange={handleRadioChange}
        >
          {roles.map((role) => (
            <FormControlLabel
              value={role}
              control={<Radio />}
              label={<TagRole label={role}></TagRole>}
            />
          ))}
        </RadioGroup>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        gap: 2,
        padding: "48px",
        paddingTop: "80px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: 2,
          paddingTop: "80px",
          width: "100%",
        }}
      >
        <Button
          size="small"
          variant="contained"
          color="secondary"
          onClick={handleClickOpenCreate}
        >
          <AddIcon />
          Add worker
        </Button>
      </Box>
      <DialogUi
        open={openCreate}
        handleClose={handleClose}
        handleSuccess={handleSuccess}
        component={workerForm()}
        title={"Add new worker"}
        buttonLabel={"Add"}
      />
      <DialogUi
        open={openEdit}
        handleClose={handleClose}
        handleSuccess={handleEdit}
        component={workerForm()}
        title={"Edit worker"}
        buttonLabel={"Save"}
      />
      <CollapsibleTable
        header={["Name", "Phone", "Role", "Photo", "Company", ""]}
        rows={users.map((user) => {
          return {
            cells: [
              user.name,
              user.phone,
              <TagRole label={user.role}></TagRole>,
              <Avatar
                alt="Logo"
                src={user.photo}
                sx={{ width: 56, height: 56 }}
              />,
              getUserCompany(user.companyId),
              <UploadButton
                id={user.id}
                label={user.photo === null ? "Upload photo" : "Change photo"}
                uploadPhoto={handleUploadPhoto}
              />,
              roleCanPerform(user.role) ? (
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => handleClickOpeEdit(user)}
                >
                  Edit
                </Button>
              ) : (
                <div />
              ),
            ],
          };
        })}
      />
    </Box>
  );
};

export default WorkerList;
